define([/* eslint-disable */
  'js/aofl-js/0.8.0/app/app',
  'js/aofl-js/0.8.0/state-configuration-service/index'
  /* eslint-enable */
], function(app) {
  'use strict';

  return function appInit(options) {
    var stateProvider;
    var urlRouterProvider;
    var couchPotatoProvider;

    app.config([
      '$stateProvider',
      '$urlRouterProvider',
      '$couchPotatoProvider',
      '$locationProvider',
      '$compileProvider',
      'html5Mode',
      'applicationDebug',
      function($stateProvider,
      $urlRouterProvider,
      $couchPotatoProvider,
      $locationProvider,
      $compileProvider,
      html5Mode,
      applicationDebug) {
        stateProvider = $stateProvider;
        urlRouterProvider = $urlRouterProvider;
        couchPotatoProvider = $couchPotatoProvider;
        $locationProvider.html5Mode(html5Mode || false);
        $compileProvider.debugInfoEnabled(applicationDebug || false);
        // $compileProvider.commentDirectivesEnabled(false);
        // $compileProvider.cssClassDirectivesEnabled(false);
      }
    ]);

    var appRunLog = function appRunLog(applicationDebug, $rootScope) {
      if (applicationDebug === true) {
        $rootScope.$on('$stateChangeStart', function(event, toState, toParams, fromState, fromParams) {
          console.log('$stateChangeStart to ' + toState.to + '- fired when the transition begins. toState,toParams : \n', toState, toParams);
          console.log(event, toState, toParams, fromState, fromParams);
        });
        $rootScope.$on('$stateChangeSuccess', function(event, toState, toParams, fromState, fromParams) {
          console.log('$stateChangeSuccess to ' + toState.name + '- fired once the state transition is complete.');
          console.log(event, toState, toParams, fromState, fromParams);
        });
        $rootScope.$on('$stateChangeError', function(event, toState, toParams, fromState, fromParams, error) {
          console.log('$stateChangeError - fired when an error occurs during transition.');
          console.log(event, toState, toParams, fromState, fromParams, error);
        });
        $rootScope.$on('$viewContentLoaded', function(event) {
          console.log('$viewContentLoaded - fired after dom rendered', event);
          console.log(event);
        });
        $rootScope.$on('$stateNotFound', function(event, unfoundState, fromState, fromParams) {
          console.log('$stateNotFound ' + unfoundState.to + '  - fired when a state cannot be found by its name.');
          console.log(event, unfoundState, fromState, fromParams);
        });
      }
    };

    app.run([
      '$couchPotato',
      '$location',
      '$state',
      '$stateParams',
      '$rootScope',
      'applicationId',
      'applicationBasePath',
      'applicationRootDir',
      'applicationDebug',
      'stateConfigurationService',
      'states',
      function(
        $couchPotato,
        $location,
        $state,
        $stateParams,
        $rootScope,
        applicationId,
        applicationBasePath,
        applicationRootDir,
        applicationDebug,
        stateConfigurationService,
        states
      ) {
        app.lazy = $couchPotato;

        $rootScope.$state = $state;
        $rootScope.$stateParams = $stateParams;
        $rootScope.applicationBasePath = applicationBasePath;
        $rootScope.applicationRootDir = applicationRootDir;

        if (typeof options.preventInitialRouteTransfer !== 'undefined' &&
        options.preventInitialRouteTransfer === true) {
          var disableInitialRouteListener = $rootScope
          .$on('$stateChangeStart', function initalStateChangeStart(event,
          toState, toParams, fromState) {
            event.preventDefault();
            $rootScope.initialState = toState;
            $rootScope.initialStateParams = toParams;
            disableInitialRouteListener();
          });
        }

        appRunLog(applicationDebug, $rootScope);

        // register states with stateProvider
        stateConfigurationService.setRouterStates(
          applicationId,
          applicationBasePath,
          states,
          urlRouterProvider,
          stateProvider,
          couchPotatoProvider
        );
      }
    ]);
  };
});
